

import { axiosRequest, AxiosRequestOptions } from "../api";
import config from '../../config';


import {
    GenerateTimetableInput,
    GenerateTimetableOutput,
    PersistTimetableItemInput,
    PersistTimetableItemOutput,
    RemoveTimetableItemOutput,
    FixizeEnrollmentStudyPeriodsStartTypeInput,
    FixizeEnrollmentStudyPeriodsStartTypeOutput,
    OrderizeEnrollmentStudyPeriodsStartTypeInput,
    OrderizeEnrollmentStudyPeriodsStartTypeOutput,
    RemoveAllTimetableItemsOutput,
    ChangeEnrollmentInput,
    ChangeEnrollmentOutput,
    ResetEnrollmentInput,
    ResetEnrollmentOutput,
    TimetableItemsQueryOutput,
    EnrollmentPortable,
    EnrollmentWithExamWithFieldWithBranchPortable,
    JobStates,
    ReportReviewInput,
    ReportReviewOutput,
    ReportProgressesInput,
    ReportProgressesOutput,
    ConfigSpeedsInput,
    ConfigSpeedsOutput,
    ConfigureChapterSpeedInput,
    ConfigureChapterSpeedOutput,
    ConfigureResourceSpeedInput,
    ConfigureResourceSpeedOutput,
    RegenerateStudyScheduleInput,
    RegenerateStudyScheduleOutput,
    UpdateEnrollmentInput,
    UpdateEnrollmentOutput,
    PostponeChapterInput,
    PostponeChapterOutput,
    StudyScheduleOutput,
    ScheduledChapterReviewsOutput,
    ChapterSpeedConfigurationOutput,
    ResourceSpeedConfigurationOutput,
    ReportableElementsOutput,
    ResourcesProgressReportsOutput,
    ChaptersPlannedTimeSumReportsOutput,
    PeriodicElementReportsOutput,
    MicroscopicPlannedResourcesOutput,
    UpdateApplicantProfileInput,
    UpdateApplicantProfileOutput,
    UpdateProfilesInput,
    UpdateProfilesOutput,
    LoadApplicantProfileOutput,
    ExamsQueryOutput,
    ExamDatesQueryOutput,
    FieldsQueryOutput,
    BranchesQueryOutput,
    ResourcePackagePersistInput,
    ResourcePackagePersistOutput,
    PackageTheResourceInput,
    PackageTheResourceOutput,
    PlanResourcesInput,
    PlanResourcesOutput,
    PlanResourceInput,
    PlanResourceOutput,
    UnplanResourceInput,
    UnplanResourceOutput,
    UpdatePlannedResourceInput,
    UpdatePlannedResourceOutput,
    ChangeProgressTypeInput,
    ChangeProgressTypeOutput,
    PlanChapterInput,
    PlanChapterOutput,
    UnplanChapterInput,
    UnplanChapterOutput,
    PlanChaptersInput,
    PlanChaptersOutput,
    UpdateTimetableItemFinishedActionInput,
    UpdateTimetableItemFinishedActionOutput,
    UpdatePlannedChapterCompletedPercentInput,
    UpdatePlannedChapterCompletedPercentOutput,
    ChangeChapterStateInput,
    ChangeChapterStateOutput,
    RequestResourceInput,
    RequestResourceOutput,
    CancelResourceRequestInput,
    CancelResourceRequestOutput,
    UpdateResourceRequestInput,
    UpdateResourceRequestOutput,
    UploadResourceRequestImageOutput,
    RemoteUploadResourceRequestImageInput,
    RemoteUploadResourceRequestImageOutput,
    ResourcePackageResourcesOutput,
    ResourceQueryOutput,
    ChaptersQueryOutput,
    PlannedChapterQueryOutput,
    PlannedResourcesQueryOutput,
    PlannedResourceDetailsOutput,
    ResourceRequestPortable,
    PreviewExternalResourceOutput,
    ConfigMaxRoundInput,
    ConfigMaxRoundOutput,
    StudyAnalyseOutput,
    ResourcePackagePortable
} from '../../types/planning';

export default {


    generateTimetable(data: GenerateTimetableInput, options?: AxiosRequestOptions) {
        return axiosRequest<GenerateTimetableOutput, GenerateTimetableInput>("POST", `${config.apiUrl.planning}/BasicPlanningCommand/GenerateTimetable`, data, options);
    },


    persistTimetableItem(data: PersistTimetableItemInput, options?: AxiosRequestOptions) {
        return axiosRequest<PersistTimetableItemOutput, PersistTimetableItemInput>("POST", `${config.apiUrl.planning}/BasicPlanningCommand/PersistTimetableItem`, data, options);
    },


    removeTimetableItem(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<RemoveTimetableItemOutput>("DELETE", `${config.apiUrl.planning}/BasicPlanningCommand/RemoveTimetableItem${queryParams || ""}`, undefined, options);
    },


    fixizeEnrollmentStudyPeriodsStartType(data: FixizeEnrollmentStudyPeriodsStartTypeInput, options?: AxiosRequestOptions) {
        return axiosRequest<FixizeEnrollmentStudyPeriodsStartTypeOutput, FixizeEnrollmentStudyPeriodsStartTypeInput>("POST", `${config.apiUrl.planning}/BasicPlanningCommand/FixizeEnrollmentStudyPeriodsStartType`, data, options);
    },


    orderizeEnrollmentStudyPeriodsStartType(data: OrderizeEnrollmentStudyPeriodsStartTypeInput, options?: AxiosRequestOptions) {
        return axiosRequest<OrderizeEnrollmentStudyPeriodsStartTypeOutput, OrderizeEnrollmentStudyPeriodsStartTypeInput>("POST", `${config.apiUrl.planning}/BasicPlanningCommand/OrderizeEnrollmentStudyPeriodsStartType`, data, options);
    },


    removeAllBasicStudyPeriods(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<RemoveAllTimetableItemsOutput>("DELETE", `${config.apiUrl.planning}/BasicPlanningCommand/RemoveAllBasicStudyPeriods${queryParams || ""}`, undefined, options);
    },


    changeEnrollment(data: ChangeEnrollmentInput, options?: AxiosRequestOptions) {
        return axiosRequest<ChangeEnrollmentOutput, ChangeEnrollmentInput>("POST", `${config.apiUrl.planning}/BasicPlanningCommand/ChangeEnrollment`, data, options);
    },


    resetEnrollment(data: ResetEnrollmentInput, options?: AxiosRequestOptions) {
        return axiosRequest<ResetEnrollmentOutput, ResetEnrollmentInput>("POST", `${config.apiUrl.planning}/BasicPlanningCommand/ResetEnrollment`, data, options);
    },


    timetableItems(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<TimetableItemsQueryOutput>("GET", `${config.apiUrl.planning}/BasicPlanningQuery/TimetableItems${queryParams || ""}`, undefined, options);
    },


    enrollment(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<EnrollmentPortable>("GET", `${config.apiUrl.planning}/BasicPlanningQuery/Enrollment${queryParams || ""}`, undefined, options);
    },


    enrollmentDetails(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<EnrollmentWithExamWithFieldWithBranchPortable>("GET", `${config.apiUrl.planning}/BasicPlanningQuery/EnrollmentDetails${queryParams || ""}`, undefined, options);
    },


    state(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<JobStates>("GET", `${config.apiUrl.planning}/Job/State${queryParams || ""}`, undefined, options);
    },


    cachedClientVersions(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest("GET", `${config.apiUrl.planning}/ManagerCore/CachedClientVersions${queryParams || ""}`, undefined, options);
    },


    invalidateClientVersionsCache(data: any, options?: AxiosRequestOptions) {
        return axiosRequest("POST", `${config.apiUrl.planning}/ManagerCore/InvalidateClientVersionsCache`, data, options);
    },


    reportReview(data: ReportReviewInput, options?: AxiosRequestOptions) {
        return axiosRequest<ReportReviewOutput, ReportReviewInput>("POST", `${config.apiUrl.planning}/MicroscopicCommand/ReportReview`, data, options);
    },


    reportProgresses(data: ReportProgressesInput, options?: AxiosRequestOptions) {
        return axiosRequest<ReportProgressesOutput, ReportProgressesInput>("POST", `${config.apiUrl.planning}/MicroscopicCommand/ReportProgresses`, data, options);
    },


    configSpeeds(data: ConfigSpeedsInput, options?: AxiosRequestOptions) {
        return axiosRequest<ConfigSpeedsOutput, ConfigSpeedsInput>("POST", `${config.apiUrl.planning}/MicroscopicCommand/ConfigSpeeds`, data, options);
    },


    configureChapterSpeed(data: ConfigureChapterSpeedInput, options?: AxiosRequestOptions) {
        return axiosRequest<ConfigureChapterSpeedOutput, ConfigureChapterSpeedInput>("POST", `${config.apiUrl.planning}/MicroscopicCommand/ConfigureChapterSpeed`, data, options);
    },


    configureResourceSpeed(data: ConfigureResourceSpeedInput, options?: AxiosRequestOptions) {
        return axiosRequest<ConfigureResourceSpeedOutput, ConfigureResourceSpeedInput>("POST", `${config.apiUrl.planning}/MicroscopicCommand/ConfigureResourceSpeed`, data, options);
    },


    regenerateStudySchedule(data: RegenerateStudyScheduleInput, options?: AxiosRequestOptions) {
        return axiosRequest<RegenerateStudyScheduleOutput, RegenerateStudyScheduleInput>("POST", `${config.apiUrl.planning}/MicroscopicCommand/RegenerateStudySchedule`, data, options);
    },


    updateEnrollment(data: UpdateEnrollmentInput, options?: AxiosRequestOptions) {
        return axiosRequest<UpdateEnrollmentOutput, UpdateEnrollmentInput>("POST", `${config.apiUrl.planning}/MicroscopicCommand/UpdateEnrollment`, data, options);
    },


    postponeChapter(data: PostponeChapterInput, options?: AxiosRequestOptions) {
        return axiosRequest<PostponeChapterOutput, PostponeChapterInput>("POST", `${config.apiUrl.planning}/MicroscopicCommand/PostponeChapter`, data, options);
    },


    studySchedule(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<StudyScheduleOutput>("GET", `${config.apiUrl.planning}/MicroscopicQuery/StudySchedule${queryParams || ""}`, undefined, options);
    },


    reviewSchedule(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ScheduledChapterReviewsOutput>("GET", `${config.apiUrl.planning}/MicroscopicQuery/ReviewSchedule${queryParams || ""}`, undefined, options);
    },


    chapterSpeedConfiguration(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ChapterSpeedConfigurationOutput>("GET", `${config.apiUrl.planning}/MicroscopicQuery/ChapterSpeedConfiguration${queryParams || ""}`, undefined, options);
    },


    resourceSpeedConfiguration(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ResourceSpeedConfigurationOutput>("GET", `${config.apiUrl.planning}/MicroscopicQuery/ResourceSpeedConfiguration${queryParams || ""}`, undefined, options);
    },


    reportableElements(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ReportableElementsOutput>("GET", `${config.apiUrl.planning}/MicroscopicQuery/ReportableElements${queryParams || ""}`, undefined, options);
    },


    resourcesProgressReports(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ResourcesProgressReportsOutput>("GET", `${config.apiUrl.planning}/MicroscopicQuery/ResourcesProgressReports${queryParams || ""}`, undefined, options);
    },


    chaptersPlannedTimeSumReports(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ChaptersPlannedTimeSumReportsOutput>("GET", `${config.apiUrl.planning}/MicroscopicQuery/ChaptersPlannedTimeSumReports${queryParams || ""}`, undefined, options);
    },


    periodicElementReports(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<PeriodicElementReportsOutput>("GET", `${config.apiUrl.planning}/MicroscopicQuery/PeriodicElementReports${queryParams || ""}`, undefined, options);
    },


    microscopicPlannedResources(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<MicroscopicPlannedResourcesOutput>("GET", `${config.apiUrl.planning}/MicroscopicQuery/MicroscopicPlannedResources${queryParams || ""}`, undefined, options);
    },


    updateApplicantProfile(data: UpdateApplicantProfileInput, options?: AxiosRequestOptions) {
        return axiosRequest<UpdateApplicantProfileOutput, UpdateApplicantProfileInput>("POST", `${config.apiUrl.planning}/PlanningGeneralCommand/UpdateApplicantProfile`, data, options);
    },


    updateProfiles(data: UpdateProfilesInput, options?: AxiosRequestOptions) {
        return axiosRequest<UpdateProfilesOutput, UpdateProfilesInput>("POST", `${config.apiUrl.planning}/PlanningGeneralCommand/UpdateProfiles`, data, options);
    },


    loadApplicantProfile(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<LoadApplicantProfileOutput>("GET", `${config.apiUrl.planning}/PlanningGeneralQuery/LoadApplicantProfile${queryParams || ""}`, undefined, options);
    },


    examsQuery(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ExamsQueryOutput>("GET", `${config.apiUrl.planning}/PlanningGeneralQuery/ExamsQuery${queryParams || ""}`, undefined, options);
    },


    examDatesQuery(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ExamDatesQueryOutput>("GET", `${config.apiUrl.planning}/PlanningGeneralQuery/ExamDatesQuery${queryParams || ""}`, undefined, options);
    },


    fieldsQuery(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<FieldsQueryOutput>("GET", `${config.apiUrl.planning}/PlanningGeneralQuery/FieldsQuery${queryParams || ""}`, undefined, options);
    },


    branchesQuery(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<BranchesQueryOutput>("GET", `${config.apiUrl.planning}/PlanningGeneralQuery/BranchesQuery${queryParams || ""}`, undefined, options);
    },


    resourcePackagePersist(data: ResourcePackagePersistInput, options?: AxiosRequestOptions) {
        return axiosRequest<ResourcePackagePersistOutput, ResourcePackagePersistInput>("POST", `${config.apiUrl.planning}/PlanningManagerCommands/ResourcePackagePersist`, data, options);
    },


    packageTheResource(data: PackageTheResourceInput, options?: AxiosRequestOptions) {
        return axiosRequest<PackageTheResourceOutput, PackageTheResourceInput>("POST", `${config.apiUrl.planning}/PlanningManagerCommands/PackageTheResource`, data, options);
    },


    planResources(data: PlanResourcesInput, options?: AxiosRequestOptions) {
        return axiosRequest<PlanResourcesOutput, PlanResourcesInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/PlanResources`, data, options);
    },


    planResource(data: PlanResourceInput, options?: AxiosRequestOptions) {
        return axiosRequest<PlanResourceOutput, PlanResourceInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/PlanResource`, data, options);
    },


    unplanResource(data: UnplanResourceInput, options?: AxiosRequestOptions) {
        return axiosRequest<UnplanResourceOutput, UnplanResourceInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/UnplanResource`, data, options);
    },


    updatePlannedResource(data: UpdatePlannedResourceInput, options?: AxiosRequestOptions) {
        return axiosRequest<UpdatePlannedResourceOutput, UpdatePlannedResourceInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/UpdatePlannedResource`, data, options);
    },


    changeProgressType(data: ChangeProgressTypeInput, options?: AxiosRequestOptions) {
        return axiosRequest<ChangeProgressTypeOutput, ChangeProgressTypeInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/ChangeProgressType`, data, options);
    },


    planChapter(data: PlanChapterInput, options?: AxiosRequestOptions) {
        return axiosRequest<PlanChapterOutput, PlanChapterInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/PlanChapter`, data, options);
    },


    unplanChapter(data: UnplanChapterInput, options?: AxiosRequestOptions) {
        return axiosRequest<UnplanChapterOutput, UnplanChapterInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/UnplanChapter`, data, options);
    },


    planChapters(data: PlanChaptersInput, options?: AxiosRequestOptions) {
        return axiosRequest<PlanChaptersOutput, PlanChaptersInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/PlanChapters`, data, options);
    },


    updateStudyPeriodFinishedAction(data: UpdateTimetableItemFinishedActionInput, options?: AxiosRequestOptions) {
        return axiosRequest<UpdateTimetableItemFinishedActionOutput, UpdateTimetableItemFinishedActionInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/UpdateStudyPeriodFinishedAction`, data, options);
    },


    updatePlannedChapterCompletedPercent(data: UpdatePlannedChapterCompletedPercentInput, options?: AxiosRequestOptions) {
        return axiosRequest<UpdatePlannedChapterCompletedPercentOutput, UpdatePlannedChapterCompletedPercentInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/UpdatePlannedChapterCompletedPercent`, data, options);
    },


    changeChapterState(data: ChangeChapterStateInput, options?: AxiosRequestOptions) {
        return axiosRequest<ChangeChapterStateOutput, ChangeChapterStateInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/ChangeChapterState`, data, options);
    },


    requestResource(data: RequestResourceInput, options?: AxiosRequestOptions) {
        return axiosRequest<RequestResourceOutput, RequestResourceInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/RequestResource`, data, options);
    },


    cancelResourceRequest(data: CancelResourceRequestInput, options?: AxiosRequestOptions) {
        return axiosRequest<CancelResourceRequestOutput, CancelResourceRequestInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/CancelResourceRequest`, data, options);
    },


    updateResourceRequest(data: UpdateResourceRequestInput, options?: AxiosRequestOptions) {
        return axiosRequest<UpdateResourceRequestOutput, UpdateResourceRequestInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/UpdateResourceRequest`, data, options);
    },


    uploadResourceRequestImage(data: any, options?: AxiosRequestOptions) {
        return axiosRequest<UploadResourceRequestImageOutput>("POST", `${config.apiUrl.planning}/ResourcesCommand/UploadResourceRequestImage`, data, options);
    },


    remoteUploadResourceRequestImage(data: RemoteUploadResourceRequestImageInput, options?: AxiosRequestOptions) {
        return axiosRequest<RemoteUploadResourceRequestImageOutput, RemoteUploadResourceRequestImageInput>("POST", `${config.apiUrl.planning}/ResourcesCommand/RemoteUploadResourceRequestImage`, data, options);
    },


    resourcePackages(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ResourcePackagePortable[]>("GET", `${config.apiUrl.planning}/ResourcesQuery/ResourcePackages${queryParams || ""}`, undefined, options);
    },


    resourcePackageResources(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ResourcePackageResourcesOutput>("GET", `${config.apiUrl.planning}/ResourcesQuery/ResourcePackageResources${queryParams || ""}`, undefined, options);
    },


    applicantResourcesQuery(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ResourceQueryOutput>("GET", `${config.apiUrl.planning}/ResourcesQuery/ApplicantResourcesQuery${queryParams || ""}`, undefined, options);
    },


    chaptersQuery(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ChaptersQueryOutput>("GET", `${config.apiUrl.planning}/ResourcesQuery/ChaptersQuery${queryParams || ""}`, undefined, options);
    },


    plannedChaptersQuery(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<PlannedChapterQueryOutput>("GET", `${config.apiUrl.planning}/ResourcesQuery/PlannedChaptersQuery${queryParams || ""}`, undefined, options);
    },


    plannedResourcesQuery(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<PlannedResourcesQueryOutput>("GET", `${config.apiUrl.planning}/ResourcesQuery/PlannedResourcesQuery${queryParams || ""}`, undefined, options);
    },


    plannedResourceDetails(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<PlannedResourceDetailsOutput>("GET", `${config.apiUrl.planning}/ResourcesQuery/PlannedResourceDetails${queryParams || ""}`, undefined, options);
    },


    resourceRequest(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<ResourceRequestPortable>("GET", `${config.apiUrl.planning}/ResourcesQuery/ResourceRequest${queryParams || ""}`, undefined, options);
    },


    previewExternalResource(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<PreviewExternalResourceOutput>("GET", `${config.apiUrl.planning}/ResourcesQuery/PreviewExternalResource${queryParams || ""}`, undefined, options);
    },


    configMaxRound(data: ConfigMaxRoundInput, options?: AxiosRequestOptions) {
        return axiosRequest<ConfigMaxRoundOutput, ConfigMaxRoundInput>("POST", `${config.apiUrl.planning}/TelescopicCommand/ConfigMaxRound`, data, options);
    },


    studyAnalyse(queryParams: string, options?: AxiosRequestOptions) {
        return axiosRequest<StudyAnalyseOutput>("GET", `${config.apiUrl.planning}/TelescopicQuery/StudyAnalyse${queryParams || ""}`, undefined, options);
    },

};